import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Modal, Button } from 'src/common';

interface FormState {
  name: string;
}

interface Props {
  onSubmit: (values: FormState) => void;
  onCancel: () => void;
  initialValues?: FormState;
}
export const CopyMpModal: FC<Props> = props => {
  const { onSubmit, onCancel, initialValues } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();

  return (
    <Modal
      title={t('Tenders.copyMp')}
      visible
      maskClosable
      onCancel={onCancel}
      footer={
        <>
          <Button type={'text'} onClick={onCancel}>
            {t('Common.cancel')}
          </Button>
          <Button type={'primary'} onClick={() => onSubmit(form.getFieldsValue())}>
            {t('Common.continue')}
          </Button>
        </>
      }
      width={500}
    >
      <Form onFinish={onSubmit} initialValues={initialValues} form={form} layout={'vertical'}>
        <Form.Item
          label={t('Common.name')}
          name={'name'}
          rules={[
            { required: true, message: t('Common.inputRequired', { inputName: t('Tenders.monitoringProfile') }) },
            { max: 30, message: t('Common.inputTooLong', { inputName: t('Tenders.monitoringProfile') }) }
          ]}
        >
          <Input data-type={'name'} type={'text'} placeholder={t('Common.name')} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CopyMpModal;
